import createDOMPurify from "dompurify";

const IFRAME_HOSTS = new Set([
  "www.youtube.com",
  "youtube.com",
  "youtu.be",
  "www.youtube-nocookie.com",
  "youtube-nocookie.com",
  "m.youtube.com",
  "player.vimeo.com",
  "vimeo.com",
  "www.vimeo.com",
  "www.loom.com",
  "loom.com",
]);

const purify = createDOMPurify(window);

purify.addHook("uponSanitizeElement", (node, data) => {
  if (data.tagName !== "iframe") return;
  const src = (node as HTMLIFrameElement).getAttribute("src") || "";
  try {
    const url = new URL(src, window.location.origin);
    if (!IFRAME_HOSTS.has(url.hostname)) {
      node.parentNode?.removeChild(node);
    }
  } catch {
    node.parentNode?.removeChild(node);
  }
});

export const SAFE_HTML_ADD_TAGS = ["iframe", "video", "audio", "source"];
export const SAFE_HTML_ADD_ATTR = [
  "allow",
  "allowfullscreen",
  "frameborder",
  "controls",
  "preload",
  "playsinline",
  "poster",
  "target",
  "rel",
  "download",
  "src",
  "type",
  "data-name",
  "data-mime",
  "data-size",
];

export default purify;
